import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const NewEventRedirect = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/benefits/event?event=new')
  }, [navigate])

  return null
}

export { NewEventRedirect }
